"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objTitle = exports.defaultObj = void 0;
// 商品默认数据结构
var defaultObj = exports.defaultObj = {
  // 基础信息
  id: undefined,
  name: '',
  intro: '',
  brandId: 0,
  keyword: '',
  image: '',
  sliderImages: [],
  sliderImage: '',
  // 如果已废弃可删除
  merchantType: 20,
  unitName: '',
  sort: 0,
  isShow: false,
  content: '',
  // brandId: '',
  type: 2,
  // 商品类型，如普通、虚拟、卡密等
  specType: false,
  // 是否多规格
  tempId: '',
  header: [],
  // 分类相关
  cateIds: [],
  // 多级分类 ID 列表
  cateId: 0,
  // 当前主分类 ID（用于提交）
  categoryId: 0,
  // 可合并为 cateId

  // 属性与规格
  attrList: [],
  // 提交用规格定义
  attrValueList: [
  // 提交用规格值列表
  {
    image: '',
    brokerage: 0,
    brokerageTwo: 0,
    price: 0.01,
    vipPrice: 0.01,
    cost: 0.01,
    otPrice: 0.01,
    stock: 0,
    barCode: '',
    itemNumber: '',
    weight: 0,
    volume: 0,
    cdkeyId: null,
    cdkeyLibraryName: '',
    expand: '',
    isShow: true
  }],
  attrs: [],
  // 渲染用规格

  // 营销与促销
  selectRule: '',
  isSub: false,
  isPaidMember: false,
  couponIds: [],
  coupons: [],
  guaranteeIds: '',
  // 可选保障计划（如逗号分隔）
  guaranteeIdsList: null,
  // 保障计划对象列表

  // 上架审核配置
  isAutoSubmitAudit: false,
  isAutoUp: false,
  // 配送与退换货
  deliveryMethodList: ['1'],
  // 支持的配送方式（如快递、同城）
  deliveryMethod: '',
  refundSwitch: true,
  // 是否支持售后退款
  systemFormId: null,
  // 限购规则与退换货规则
  limitBuyRuleIds: [],
  // 限购规则ID
  productReturnRuleIds: [],
  // 退货规则ID

  // 扩展字段
  ext: {
    reservation: '是',
    // 是否可预约
    limitRule: '',
    // 限购规则描述
    productReturn: '',
    // 退货说明
    runTime: '',
    // 销售时间段
    topKnow: '',
    // 顶部须知
    limitUse: '',
    // 使用限制
    useRule: '' // 使用规则
  },
  // 其他
  lastDay: '' // 最后有效日期
};

// 商品字段标题映射
var objTitle = exports.objTitle = {
  price: {
    title: '售价（元）'
  },
  vipPrice: {
    title: '会员价（元）'
  },
  cost: {
    title: '成本价（元）'
  },
  otPrice: {
    title: '划线价（元）'
  },
  stock: {
    title: '库存'
  },
  barCode: {
    title: '商品编码'
  },
  itemNumber: {
    title: '商品条码'
  },
  weight: {
    title: '重量（KG）'
  },
  volume: {
    title: '体积(m³)'
  },
  brokerage: {
    title: '一级返佣(%)'
  },
  brokerageTwo: {
    title: '二级返佣(%)'
  }
};